export const REQUIRE_VERIFY_MAIL = 'REQUIRE_VERIFY_MAIL';
export const VERIFY_MAIL_SUCCESS = 'VERIFY_MAIL_SUCCESS';
export const VERIFY_MAIL_FAIL = 'VERIFY_MAIL_FAIL';

export const REQUIRE_VERIFY_OTP = 'REQUIRE_VERIFY_OTP';
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_FAIL = 'VERIFY_OTP_FAIL';

export const REQUIRE_SEND_DETAILS = 'REQUIRE_SEND_DETAILS';
export const SEND_DETAILS_SUCCESS = 'SEND_DETAILS_SUCCESS';
export const SEND_DETAILS_FAIL = 'SEND_DETAILS_FAIL';

export const REQUIRE_LOGIN_DETAILS = "REQUIRE_LOGIN_DETAILS";
export const LOGIN_DETAILS_SUCCESS = "LOGIN_DETAILS_SUCCESS";
export const LOGIN_DETAILS_FAIL = "LOGIN_DETAILS_FAIL";

export const REQUIRE_LINK_SEND = "REQUIRE_LINK_SEND";
export const LINK_SEND_SUCCESS = "LINK_SEND_SUCCESS";
export const LINK_SEND_FAIL = "LINK_SEND_FAIL";

export const REQUIRE_RESET_PASSWORD = "REQUIRE_RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";
